import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'styles/colors';
import fonts from 'styles/fonts';

const useStyles = makeStyles({
  progressText: {
    marginTop: '4px',
    color: colors.black,
    fontWeight: fonts.weights.normal,
    fontSize: fonts.sizes.xsmall,
    letterSpacing: '0.4px',
    lineHeight: '16px',
  },
});

export default useStyles;
